module.exports = __webpack_public_path__ + "img/groovepaybr-integration.4684c118.png";